const Select2View = Backbone.View.extend({
	events: {
		'select2:select' :  'select2Cb',
		'keydown': 'clearField'
	},
	initialize() {
		this.$el.select2({
			minimumInputLength: 2,
			placeholder: 'Enter Name or Email',
			ajax: {
				url: '/api/Users/GetUserByFragment',
				dataType: 'json',
				delay: 300,
				data: (params) => {
					return {'userFragment': params.term};
				},
				processResults: (data) => {
					this.trigger('fetched', data);
					return {results: []};
				}
			}
		});
	},
	select2Cb(e) {
		this.trigger('selected', e.params.data );
	}
});

export default Select2View;
